import {EventHandler} from "../EventDispatcher";
import {IpcMainInvokeEvent} from "electron";
import getChangeDocumentStatus from "../../DependencyInjection/changeDocumentStatus";
import DocumentDownload from "../../Entity/DocumentDownload";
import Status from "../../ValueObject/Status";

const ChangeDocumentStatusToDownloadingListener: EventHandler<DocumentDownload> = async (event: IpcMainInvokeEvent, content: DocumentDownload): Promise<void> => {
    const document: DocumentDownload = DocumentDownload.from(content);
    getChangeDocumentStatus().change(document.getIdString(), Status.DOWNLOADING);
}

const ChangeDocumentStatusToPausedListener: EventHandler<DocumentDownload> = async (event: IpcMainInvokeEvent, content: DocumentDownload): Promise<void> => {
    const document: DocumentDownload = DocumentDownload.from(content);
    getChangeDocumentStatus().change(document.getIdString(), Status.PAUSED);
}

const ChangeDocumentStatusToProcessingListener: EventHandler<DocumentDownload> = async (event: IpcMainInvokeEvent, content: DocumentDownload): Promise<void> => {
    const document: DocumentDownload = DocumentDownload.from(content);
    getChangeDocumentStatus().change(document.getIdString(), Status.PROCESSING);
}

const ChangeDocumentStatusToDownloadedListener: EventHandler<DocumentDownload> = async (event: IpcMainInvokeEvent, content: DocumentDownload): Promise<void> => {
    const document: DocumentDownload = DocumentDownload.from(content);
    getChangeDocumentStatus().change(document.getIdString(), Status.DOWNLOADED);
}

export {
    ChangeDocumentStatusToDownloadingListener,
    ChangeDocumentStatusToPausedListener,
    ChangeDocumentStatusToProcessingListener,
    ChangeDocumentStatusToDownloadedListener
};